import request from "../request";

/**
 * Get all seed configurations
 * @returns {Promise} Promise that resolves to array of seed configurations
 */
export const getSeedConfigurations = () => {
	return request({
		url: "/seeder/seed-configurations",
		method: "GET",
	});
};

/**
 * Get a specific seed configuration by ID
 * @param {string} configurationId - The ID of the configuration to fetch
 * @returns {Promise} Promise that resolves to the configuration data
 */
export const getSeedConfigurationById = (configurationId) => {
	return request({
		url: `/seeder/seed-configurations/${configurationId}`,
		method: "GET",
	});
};

/**
 * Create a new seed configuration
 * @param {Object} configurationData - The configuration data to save
 * @returns {Promise} Promise that resolves to the created configuration
 */
export const createSeedConfiguration = (configurationData) => {
	return request({
		url: "/seeder/seed-configurations",
		method: "POST",
		data: configurationData,
	});
};

/**
 * Update an existing seed configuration
 * @param {string} configurationId - The ID of the configuration to update
 * @param {Object} configurationData - The updated configuration data
 * @returns {Promise} Promise that resolves to the updated configuration
 */
export const updateSeedConfiguration = (configurationId, configurationData) => {
	return request({
		url: `/seeder/seed-configurations/${configurationId}`,
		method: "PUT",
		data: configurationData,
	});
};

/**
 * Delete a seed configuration
 * @param {string} configurationId - The ID of the configuration to delete
 * @returns {Promise} Promise that resolves when deletion is complete
 */
export const deleteSeedConfiguration = (configurationId) => {
	return request({
		url: `/seeder/seed-configurations/${configurationId}`,
		method: "DELETE",
	});
};

/**
 * Create a workflow dispatch event for a given seed configuration
 * @param {Object} seedConfiguration - The seed configuration to dispatch
 * @returns {Promise} Promise that resolves to the workflow dispatch response
 */
export const createWorkflowDispatchEvent = (seedConfiguration) => {
	return request({
		url: "/seeder/create-workflow-dispatch-event",
		method: "POST",
		data: { seedConfiguration },
	});
};

/**
 * Get a workflow run by its ID
 * @param {string} runId - The ID of the workflow run
 * @returns {Promise} Promise that resolves to the workflow run data
 */
export const getWorkflowRunById = (runId) => {
	return request({
		url: `/seeder/get-workflow-run-by-id/${runId}`,
		method: "GET",
	});
};

/**
 * Fetch workflow run logs by run ID
 * @param {string} runId - The ID of the workflow run
 * @returns {Promise} Promise that resolves to the workflow run logs
 */
export const fetchWorkflowRunLogsById = (runId) => {
	return request({
		url: `/seeder/get-workflow-run-logs-by-id/${runId}`,
		method: "GET",
	});
};

export const createCompanyLog = (log) => {
	return request({
		url: "/seeder/create-company-log",
		method: "POST",
		data: log,
	});
};

export const fetchCompanyLogs = () => {
	return request({
		url: "/seeder/company-logs",
		method: "GET",
	});
};
